<div class="flex w-full items-center justify-center">
  @if (width() && url()) {
    <img
      class="mr-0 rounded-full border-[1px] border-solid border-[var(sys-outline)] bg-contain bg-center bg-no-repeat"
      [style]="'width:' + width() + 'px;' + 'height:' + width() + 'px;'"
      [src]="url()"
      onContextMenu="return false;"
    />
  }
</div>
